module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div'), _vm._v(" "), (_vm.clientID > 0) ? _c('b-button', {
    staticClass: "mb-1 mt-1",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "size": "xs"
    },
    on: {
      "click": function($event) {
        _vm.openClientMOM(_vm.clientID)
      }
    }
  }, [_vm._v("Add MOM")]) : _vm._e(), _vm._v(" "), _c('b-modal', {
    ref: "ClientMom-modal",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "size": "xl",
      "hide-footer": "",
      "title": _vm.Page_title
    }
  }, [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e(), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("\n          Meeting Attendend by Pridel Side\n          "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('multi-select', {
    attrs: {
      "options": _vm.$store.getters['common/getAllMultiUserList'],
      "selected-options": _vm.PridelSideUser_items,
      "placeholder": "Select Pridel Side User",
      "multiple": true,
      "id": "fk_mom_pridel_user_id"
    },
    on: {
      "select": _vm.SelectMultiPridelSideUser
    },
    model: {
      value: (_vm.clentMomForm.fk_mom_pridel_user_id),
      callback: function($$v) {
        _vm.$set(_vm.clentMomForm, "fk_mom_pridel_user_id", $$v)
      },
      expression: "clentMomForm.fk_mom_pridel_user_id"
    }
  }), _vm._v(" "), (!_vm.clentMomForm.fk_mom_pridel_user_id) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n          " + _vm._s(_vm.errorList.fk_mom_pridel_user_id) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("\n          Meeting Attendend by Client Side\n          "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('multi-select', {
    attrs: {
      "options": _vm.$store.getters['common/getAllMultiUserList'],
      "selected-options": _vm.ClientSideUser_items,
      "placeholder": "Select Client Side User",
      "multiple": true,
      "id": "mom_user"
    },
    on: {
      "select": _vm.SelectMultiClientSideUser
    },
    model: {
      value: (_vm.clentMomForm.mom_user),
      callback: function($$v) {
        _vm.$set(_vm.clentMomForm, "mom_user", $$v)
      },
      expression: "clentMomForm.mom_user"
    }
  }), _vm._v(" "), (!_vm.clentMomForm.mom_user) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n          " + _vm._s(_vm.errorList.mom_user) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("\n          Other Client Side User\n          "), _c('span', {
    staticClass: "error"
  })]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "mom_name",
      "name": "mom_name",
      "placeholder": "`Please Enter Other Client User Name",
      "type": "text"
    },
    model: {
      value: (_vm.clentMomForm.other_mom_user_name),
      callback: function($$v) {
        _vm.$set(_vm.clentMomForm, "other_mom_user_name", $$v)
      },
      expression: "clentMomForm.other_mom_user_name"
    }
  }), _vm._v(" "), (!_vm.clentMomForm.other_mom_user_name) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n          " + _vm._s(_vm.errorList.other_mom_user_name) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("\n          Date Time\n          "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _c('br'), _vm._v(" "), _c('date-picker', {
    attrs: {
      "lang": "en",
      "name": "mom_datetime",
      "id": "mom_datetime",
      "type": "datetime",
      "format": "YYYY-MM-DD hh:mm a",
      "minute-step": 1
    },
    model: {
      value: (_vm.clentMomForm.mom_datetime),
      callback: function($$v) {
        _vm.$set(_vm.clentMomForm, "mom_datetime", $$v)
      },
      expression: "clentMomForm.mom_datetime"
    }
  }), _c('br'), _vm._v(" "), (!_vm.clentMomForm.mom_datetime) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n          " + _vm._s(_vm.errorList.mom_datetime) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("\n          Venue\n          "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "mom_venue",
      "name": "mom_venue",
      "type": "text",
      "placeholder": "Please Enter Venue"
    },
    model: {
      value: (_vm.clentMomForm.mom_venue),
      callback: function($$v) {
        _vm.$set(_vm.clentMomForm, "mom_venue", $$v)
      },
      expression: "clentMomForm.mom_venue"
    }
  }), _vm._v(" "), (!_vm.clentMomForm.mom_venue) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n          " + _vm._s(_vm.errorList.mom_venue) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("\n          Further Action\n          "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.furtoreAction,
      "id": "mom_further_action",
      "option-value": "value",
      "option-text": "text",
      "placeholder": "Please Select Further Action"
    },
    model: {
      value: (_vm.clentMomForm.mom_further_action),
      callback: function($$v) {
        _vm.$set(_vm.clentMomForm, "mom_further_action", $$v)
      },
      expression: "clentMomForm.mom_further_action"
    }
  }), _vm._v(" "), (!_vm.clentMomForm.mom_further_action) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n          " + _vm._s(_vm.errorList.mom_further_action) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("\n          Followup Date\n          "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _c('br'), _vm._v(" "), _c('date-picker', {
    attrs: {
      "lang": "en",
      "name": "mom_followupdate",
      "id": "mom_followupdate",
      "type": "date",
      "format": "YYYY-MM-DD",
      "minute-step": 1
    },
    model: {
      value: (_vm.clentMomForm.mom_followupdate),
      callback: function($$v) {
        _vm.$set(_vm.clentMomForm, "mom_followupdate", $$v)
      },
      expression: "clentMomForm.mom_followupdate"
    }
  }), _c('br'), _vm._v(" "), (!_vm.clentMomForm.mom_followupdate) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n          " + _vm._s(_vm.errorList.mom_followupdate) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("\n          Followup Time\n          "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _c('br'), _vm._v(" "), _c('date-picker', {
    attrs: {
      "lang": "en",
      "name": "mom_followup_time",
      "id": "mom_followup_time",
      "type": "time",
      "format": "hh:mm a",
      "minute-step": 1
    },
    model: {
      value: (_vm.clentMomForm.mom_followup_time),
      callback: function($$v) {
        _vm.$set(_vm.clentMomForm, "mom_followup_time", $$v)
      },
      expression: "clentMomForm.mom_followup_time"
    }
  }), _c('br'), _vm._v(" "), (!_vm.clentMomForm.mom_followup_time) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n          " + _vm._s(_vm.errorList.mom_followup_time) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Assign To")]), _vm._v(" "), _c('multi-select', {
    attrs: {
      "options": _vm.$store.getters['common/getAllMultiUserList'],
      "selected-options": _vm.AssignedUser_items,
      "placeholder": "Select Assign To",
      "multiple": true,
      "id": "assigned_user"
    },
    on: {
      "select": _vm.SelectMultiAssignedUser
    },
    model: {
      value: (_vm.clentMomForm.assigned_user),
      callback: function($$v) {
        _vm.$set(_vm.clentMomForm, "assigned_user", $$v)
      },
      expression: "clentMomForm.assigned_user"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("\n          Remark\n          "), _c('span', {
    staticClass: "error"
  })]), _vm._v(" "), _c('b-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "mom_remark",
      "name": "mom_remark",
      "type": "text",
      "placeholder": "Please Enter Remark",
      "rows": "2"
    },
    model: {
      value: (_vm.clentMomForm.mom_remark),
      callback: function($$v) {
        _vm.$set(_vm.clentMomForm, "mom_remark", $$v)
      },
      expression: "clentMomForm.mom_remark"
    }
  }), _vm._v(" "), (!_vm.clentMomForm.mom_remark) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n          " + _vm._s(_vm.errorList.mom_remark) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('label', [_vm._v("\n          Minutes of Meeting\n          "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('quill-editor', {
    staticStyle: {
      "width": "100% !important",
      "height": "300px !important",
      "background": "#fff",
      "display": "inline-block"
    },
    attrs: {
      "options": _vm.editorOptions
    },
    model: {
      value: (_vm.clentMomForm.mom_minutes_of_meeting),
      callback: function($$v) {
        _vm.$set(_vm.clentMomForm, "mom_minutes_of_meeting", $$v)
      },
      expression: "clentMomForm.mom_minutes_of_meeting"
    }
  }), _vm._v(" "), (!_vm.clentMomForm.mom_minutes_of_meeting) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n          " + _vm._s(_vm.errorList.mom_minutes_of_meeting) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "text-center",
    attrs: {
      "cols": "12"
    }
  }, [_c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "primary",
      "id": "saveClientMOM"
    },
    on: {
      "click": _vm.saveClientMOM
    }
  }, [_vm._v("Save\n        ")]), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.hideClientMOMModal
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56a93db9","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/clientJob/clientMOM.vue
// module id = 2649
// module chunks = 0